import React from 'react';
import { X, Check } from 'lucide-react';
export function ComparisonTable() {
  return <div className="my-12 bg-white rounded-2xl shadow-xl overflow-hidden border border-gray-200" data-id="element-1">
      <div className="bg-gradient-to-r from-gray-50 to-gray-100 px-6 py-4 border-b border-gray-200" data-id="element-2">
        <h3 className="text-2xl font-serif font-bold text-center text-gray-900" data-id="element-3">
          Why Mesh Bags Fail vs. ReLive Chenille
        </h3>
      </div>

      <div className="grid md:grid-cols-2 divide-x divide-gray-200" data-id="element-4">
        {/* Left Side - Mesh Bags */}
        <div className="p-8 bg-red-50/30" data-id="element-5">
          <div className="flex items-center justify-center gap-3 mb-6" data-id="element-6">
            <div className="w-12 h-12 rounded-full bg-red-100 flex items-center justify-center" data-id="element-7">
              <X className="w-7 h-7 text-red-600" strokeWidth={3} data-id="element-8" />
            </div>
            <h4 className="text-xl font-bold text-gray-900" data-id="element-9">
              Standard Mesh Bags
            </h4>
          </div>

          <ul className="space-y-4" data-id="element-10">
            <li className="flex items-start gap-3" data-id="element-11">
              <X className="w-5 h-5 text-red-600 flex-shrink-0 mt-0.5" data-id="element-12" />
              <span className="text-gray-700" data-id="element-13">Zero Impact Protection</span>
            </li>
            <li className="flex items-start gap-3" data-id="element-14">
              <X className="w-5 h-5 text-red-600 flex-shrink-0 mt-0.5" data-id="element-15" />
              <span className="text-gray-700" data-id="element-16">
                Shoes Bang Against Metal Drum
              </span>
            </li>
            <li className="flex items-start gap-3" data-id="element-17">
              <X className="w-5 h-5 text-red-600 flex-shrink-0 mt-0.5" data-id="element-18" />
              <span className="text-gray-700" data-id="element-19">
                Does Not Clean Grooves or Treads
              </span>
            </li>
            <li className="flex items-start gap-3" data-id="element-20">
              <X className="w-5 h-5 text-red-600 flex-shrink-0 mt-0.5" data-id="element-21" />
              <span className="text-gray-700" data-id="element-22">Thin Fabric Tears Easily</span>
            </li>
            <li className="flex items-start gap-3" data-id="element-23">
              <X className="w-5 h-5 text-red-600 flex-shrink-0 mt-0.5" data-id="element-24" />
              <span className="text-gray-700" data-id="element-25">Loud "Freight Train" Noise</span>
            </li>
          </ul>
        </div>

        {/* Right Side - ReLive */}
        <div className="p-8 bg-green-50/30" data-id="element-26">
          <div className="flex items-center justify-center gap-3 mb-6" data-id="element-27">
            <div className="w-12 h-12 rounded-full bg-[#2d5016] flex items-center justify-center" data-id="element-28">
              <Check className="w-7 h-7 text-white" strokeWidth={3} data-id="element-29" />
            </div>
            <h4 className="text-xl font-bold text-gray-900" data-id="element-30">
              ReLive Chenille Bag
            </h4>
          </div>

          <ul className="space-y-4" data-id="element-31">
            <li className="flex items-start gap-3" data-id="element-32">
              <Check className="w-5 h-5 text-[#2d5016] flex-shrink-0 mt-0.5" data-id="element-33" />
              <span className="text-gray-700" data-id="element-34">
                <strong data-id="element-35">360° Padded Cushioning</strong>
              </span>
            </li>
            <li className="flex items-start gap-3" data-id="element-36">
              <Check className="w-5 h-5 text-[#2d5016] flex-shrink-0 mt-0.5" data-id="element-37" />
              <span className="text-gray-700" data-id="element-38">
                <strong data-id="element-39">Absorbs Shock & Noise</strong>
              </span>
            </li>
            <li className="flex items-start gap-3" data-id="element-40">
              <Check className="w-5 h-5 text-[#2d5016] flex-shrink-0 mt-0.5" data-id="element-41" />
              <span className="text-gray-700" data-id="element-42">
                <strong data-id="element-43">Active Microfiber Scrubbing</strong>
              </span>
            </li>
            <li className="flex items-start gap-3" data-id="element-44">
              <Check className="w-5 h-5 text-[#2d5016] flex-shrink-0 mt-0.5" data-id="element-45" />
              <span className="text-gray-700" data-id="element-46">
                <strong data-id="element-47">Heavy-Duty Construction</strong>
              </span>
            </li>
            <li className="flex items-start gap-3" data-id="element-48">
              <Check className="w-5 h-5 text-[#2d5016] flex-shrink-0 mt-0.5" data-id="element-49" />
              <span className="text-gray-700" data-id="element-50">
                <strong data-id="element-51">Whisper-Quiet Operation</strong>
              </span>
            </li>
          </ul>
        </div>
      </div>
    </div>;
}